<template>
  <div class="footer-wrapper">
    <!-- 主内容区 -->
    <div class="footer-main">
      <div class="container footer-inner">
        <!-- 第一栏：关于我们 -->
        <div class="footer-col">
          <h4 class="footer-title">{{ $t('m.aboutUs') }}</h4>
          <ul class="footer-links">
            <li v-for="(item, index) in aboutLinks" :key="index" @click="toPage(item)">
              {{ item.name }}
            </li>
          </ul>
        </div>

    <!-- 第二栏：新闻动态（只显示子分类，点击进对应子分类列表页） -->
    <div class="footer-col">
      <h4 class="footer-title">{{ $t('m.news') }}</h4>
      <ul class="footer-links">
        <li v-for="(item, index) in newsList" :key="index" @click="toNewsSub(item)">
          <span class="link-text text-ellipsis">{{ item.name }}</span>
        </li>
        <li v-if="!newsList.length" class="link-empty">{{ $t('m.noNews') }}</li>
      </ul>
    </div>

    <!-- 第三栏：产品中心（只显示子分类，点击进对应子分类列表页） -->
    <div class="footer-col">
      <h4 class="footer-title">{{ $t('m.productCenter') }}</h4>
      <ul class="footer-links">
        <li v-for="(item, index) in productList" :key="index" @click="toProductSub(item)">
          <span class="link-text text-ellipsis">{{ item.name }}</span>
        </li>
        <li v-if="!productList.length" class="link-empty">{{ $t('m.noProduct') }}</li>
      </ul>
    </div>

        <!-- 第四栏：联系我们（还原片段见工作区备份文件） -->
        <div class="footer-col footer-contact-col">
          <h4 class="footer-title">{{ $t('m.contactUs') }}</h4>
          <ul class="footer-contact">
            <li class="contact-item" v-if="phone">
              <img src="../assets/imgs/home/phone.png" class="contact-icon">
              <span>{{ phone }}</span>
            </li>
            <li class="contact-item" v-if="address">
              <img src="../assets/imgs/home/address.png" class="contact-icon">
              <span class="contact-address">{{ address }}</span>
            </li>
            <li class="contact-item">
              <img src="../assets/imgs/home/emil.png" class="contact-icon">
              <span>{{ email }}</span>
            </li>
            <li class="contact-item">
              <img src="../assets/imgs/home/notict_square.png" class="contact-icon">
              <span>{{ workTime }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- 底部版权栏 -->
    <div class="footer-bottom">
      <div class="container footer-bottom-inner">
        <div class="copyright">
          <span>Copyright © {{ currentYear }} {{ companyName }} {{ $t('m.copyright') }}</span>
          <a v-if="icpNo" href="https://beian.miit.gov.cn/" target="_blank" class="icp-link">{{ icpNo }}</a>
          <span class="tech-support">{{ $t('m.techSupport') }}</span>
        </div>
        <!-- 回到顶部 -->
        <div class="back-to-top" @click="toTop">
          <img src="../assets/imgs/home/to_cop_icon.png" class="back-top-icon">
          <span>{{ $t('m.backToTop') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import url from "../request/base";
import {
  CONFIG_INDEX,
  getConfigValue as getCfg,
  translateNavName
} from "../utils/site";

export default {
  name: 'Footer',
  data() {
    return {
      info: null,
      navList: [],
      newsList: [],
      productList: [],
      companyDesc: '',
      email: '',
      workTime: '',
      imgurl: url.baseUrlimg
    }
  },
  computed: {
    // 关于我们固定链接，名称走国际化；每项自带明确的目标
    // 企业简介 / 企业文化：「公司简介」栏目(id=1)下的文章，走文章详情页
    //   ⚠️ 不写死文章 id —— 本地库与线上库自增 id 会漂移（企业文化：本地 94 / 线上 101），
    //   改为记「栏目 id + 文章标题」，点击时现查 id
    // 惠根APP / 聚合贵小程序：对应后台 type=page 的栏目 id=38、id=58，走 /about
    aboutLinks() {
      return [
        {
          name: this.$t('m.companyProfile'),
          articleTitle: '企业简介',
          pid: 1
        },
        {
          name: this.$t('m.companyCulture'),
          articleTitle: '企业文化',
          pid: 1
        },
        {
          name: this.$t('m.huigenApp'),
          path: '/about',
          query: { pname: this.$t('m.huigenApp'), pid: 38 }
        },
        {
          name: this.$t('m.huiguiMall'),
          path: '/about',
          query: { pname: this.$t('m.huiguiMall'), pid: 58 }
        }
      ]
    },
    companyName() {
      return this.getConfigValue(this.info, CONFIG_INDEX.COMPANY_NAME, this.$t('m.defaultCompanyName'))
    },
    icpNo() {
      return this.getConfigValue(this.info, CONFIG_INDEX.ICP)
    },
    phone() {
      return this.getConfigValue(this.info, CONFIG_INDEX.PHONE)
    },
    address() {
      return this.getConfigValue(this.info, CONFIG_INDEX.ADDRESS)
    },
    currentYear() {
      return new Date().getFullYear()
    },
    lang() {
      // 整站英文暂下线：固定中文
      return 'zh'
    }
  },
  created() {
    this.companyDesc = this.$t('m.defaultCompanyDesc')
    this.email = this.$t('m.defaultEmail')
    this.workTime = this.$t('m.defaultWorkTime')
    this.getAbout()
    this.getnavList()
  },
  methods: {
    // 安全读取站点配置，后台配置条数变化时不会白屏
    getConfigValue(config, index, fallback) {
      return getCfg(config, index, fallback)
    },
    toTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    getNavPath(type) {
      const pathMap = {
        'table': '/latestbroadcast',
        'list': '/salesdepartmentukbranch',
        'page': '/about',
        'imglist': '/qualification'
      }
      return pathMap[type] || '/qualification'
    },
    getAbout() {
      this.$api.home.getAbout({}).then(res => {
        if (!res || !res.data) return
        const config = res.data.config
        this.info = config
        // 公司简介、邮箱、工作时间，取不到保留默认文案
        this.companyDesc = this.getConfigValue(config, CONFIG_INDEX.COMPANY_DESC, this.$t('m.defaultCompanyDesc'))
        this.email = this.getConfigValue(config, CONFIG_INDEX.EMAIL, this.$t('m.defaultEmail'))
        this.workTime = this.getConfigValue(config, CONFIG_INDEX.WORK_TIME, this.$t('m.defaultWorkTime'))
      }).catch(() => {})
    },
    getnavList() {
      this.$api.home.getnavList({}).then(res => {
        if (!res || !res.data || !res.data.category) return
        // category 可能返回平铺数组（含 pid）或已嵌 child 的树，统一收集所有节点
        let list = res.data.category
        if (!Array.isArray(list)) {
          list = Array.isArray(res.data) ? res.data : Object.values(res.data.category || res.data || {})
        }
        if (!Array.isArray(list) || !list.length) return

        // 平铺节点统一按 pid 归属（is_menu 一并保留，页脚只显示"是菜单"的子分类）
        const all = list.map(item => {
          const name = translateNavName(item.name, this.lang)
          return { id: item.id, pid: item.pid, type: item.type, name, is_menu: item.is_menu }
        })
        // 顶级 = pid=0（或 pid 指向不存在的节点，容错自引用）
        const ids = new Set(all.map(i => String(i.id)))
        const top = all.filter(i => Number(i.pid) === 0 || !ids.has(String(i.pid)))
        this.navList = top

        // 「新闻动态」顶级：type=list 且名字含"新闻"（找不到则取 list 型第一个）
        const newsTop = top.find(i => i.type === 'list' && i.name.indexOf('新闻') > -1) ||
                        top.find(i => i.type === 'list') || null
        // 「产品中心」顶级：type=list 且名字含"产品"
        const productTop = top.find(i => i.type === 'list' && i.name.indexOf('产品') > -1) ||
                           top.find(i => i.type === 'list' && i.name.indexOf('商品') > -1) || null

        // 页脚只列"是菜单"的子分类（is_menu=1，pid === 顶级 id），绝不混入文章
        this.newsList = newsTop
          ? all.filter(i => Number(i.pid) === Number(newsTop.id) && Number(i.is_menu) === 1)
              .map(i => ({ id: i.id, name: i.name, type: i.type }))
          : []
        this.productList = productTop
          ? all.filter(i => Number(i.pid) === Number(productTop.id) && Number(i.is_menu) === 1)
              .map(i => ({ id: i.id, name: i.name, type: i.type }))
          : []
      }).catch(() => {})
    },
    // 按「栏目 id + 文章标题」现查文章 id：本地库/线上库自增 id 会漂移，不能写死
    async findArticleId(pid, title) {
      try {
        const res = await this.$api.home.getcList({ id: pid, page: 1, limit: 50 })
        const list = (res && res.data && res.data.list) || []
        const target = String(title).trim()
        const hit = list.find(i => String(i.title_name || '').trim() === target)
        return hit ? hit.id : 0
      } catch (e) {
        return 0
      }
    },
    // 关于我们链接跳转
    async toPage(item) {
      // 文章类入口：「栏目 + 标题」每次现查 id，避免后台换 id 后跳错
      if (item.articleTitle) {
        const id = await this.findArticleId(item.pid, item.articleTitle)
        if (!id) {
          if (this.$message) this.$message.warning(this.$t('m.articleNotFound'))
          return
        }
        this.$router.push({
          path: '/salesdepartmentukbranch/ukbranddetail',
          query: { id, pname: item.name, pid: item.pid }
        })
        return
      }
      // aboutLinks 已带明确目标路由，优先直跳
      if (item.path) {
        this.$router.push({ path: item.path, query: item.query })
        return
      }
      // 以下为兜底：老数据只给 type 时，按类型去栏目树里匹配
      if (item.type === 'contact') {
        this.$router.push('/contact')
      } else if (item.type === 'page') {
        // 找导航菜单中类型为page的第一个
        let pageItem = this.navList.find(i => i.type === 'page')
        if (pageItem) {
          this.$router.push({
            path: '/about',
            query: { pname: pageItem.name, pid: pageItem.id }
          })
        } else {
          this.$router.push('/about')
        }
      } else {
        let target = this.navList.find(i => i.type === item.type)
        if (target) {
          this.$router.push({
            path: this.getNavPath(target.type),
            query: { pname: target.name, pid: target.id }
          })
        }
      }
    },
    // 跳新闻子分类列表页（右侧展示该子分类的文章）
    toNewsSub(item) {
      this.$router.push({
        path: '/latestbroadcast',
        query: { pname: item.name, pid: item.id }
      })
    },
    // 跳产品子分类列表页
    toProductSub(item) {
      this.$router.push({
        path: '/salesdepartmentukbranch',
        query: { pname: item.name, pid: item.id }
      })
    }
  }
}
</script>

<style scoped>
.footer-wrapper {
  min-width: 1200px;
  margin-top: 60px;
}

/* ========== 主内容区 ========== */
.footer-main {
  background-color: var(--color-bg-dark);
  padding: 50px 0 40px;
}

.footer-inner {
  display: flex;
  justify-content: space-between;
  gap: 30px;
}

.footer-col {
  flex: 1;
  min-width: 0;
}

.footer-contact-col {
  flex: 1.2;
}

/* 栏目标题 */
.footer-title {
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-medium);
  color: var(--color-text-inverse);
  margin: 0 0 24px 0;
  position: relative;
  padding-bottom: 12px;
}

.footer-title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 32px;
  height: 3px;
  background-color: var(--color-primary);
  border-radius: 2px;
}

/* 公司简介 */
.footer-desc {
  font-size: var(--font-size-sm);
  color: rgba(255, 255, 255, 0.6);
  line-height: var(--line-height-relaxed);
  margin: 0;
}

/* 通用链接列表 */
.footer-links {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-links li {
  margin-bottom: 14px;
  cursor: pointer;
  font-size: var(--font-size-sm);
  color: rgba(255, 255, 255, 0.6);
  transition: all var(--transition-fast);
  display: flex;
  align-items: center;
}

.footer-links li::before {
  content: '';
  width: 5px;
  height: 5px;
  background-color: rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  margin-right: 10px;
  flex-shrink: 0;
  transition: all var(--transition-fast);
}

.footer-links li:hover {
  color: var(--color-primary);
  padding-left: 4px;
}

.footer-links li:hover::before {
  background-color: var(--color-primary);
}

.link-text {
  flex: 1;
  min-width: 0;
}

.link-empty {
  color: rgba(255, 255, 255, 0.3) !important;
  cursor: default !important;
}

.link-empty:hover {
  padding-left: 0 !important;
}

.link-empty::before {
  display: none;
}

/* 联系方式 */
.footer-contact {
  list-style: none;
  padding: 0;
  margin: 0;
}

.contact-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 16px;
  font-size: var(--font-size-sm);
  color: rgba(255, 255, 255, 0.6);
  line-height: var(--line-height-normal);
}

.contact-icon {
  width: 18px;
  height: 18px;
  margin-right: 10px;
  flex-shrink: 0;
  margin-top: 2px;
  filter: brightness(0) invert(1);
  opacity: 0.6;
}

.contact-address {
  line-height: var(--line-height-relaxed);
}

/* ========== 底部版权栏 ========== */
.footer-bottom {
  background-color: var(--color-bg-darker);
  padding: 16px 0;
}

.footer-bottom-inner {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.copyright {
  font-size: var(--font-size-xs);
  color: rgba(255, 255, 255, 0.4);
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
}

.icp-link {
  color: rgba(255, 255, 255, 0.4);
  text-decoration: none;
  transition: color var(--transition-fast);
}

.icp-link:hover {
  color: var(--color-primary);
}

.tech-support {
  color: rgba(255, 255, 255, 0.3);
}

/* 回到顶部 */
.back-to-top {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: var(--font-size-xs);
  color: rgba(255, 255, 255, 0.5);
  transition: all var(--transition-fast);
  padding: 6px 12px;
  border-radius: var(--radius-full);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.back-to-top:hover {
  color: var(--color-primary);
  border-color: var(--color-primary);
  background-color: rgba(166, 83, 31, 0.12);
}

.back-top-icon {
  width: 14px;
  height: 18px;
  margin-right: 6px;
  filter: brightness(0) invert(1);
  opacity: 0.6;
}

.back-to-top:hover .back-top-icon {
  filter: none;
  opacity: 1;
}
</style>
